import {
  FileSelectorModal,
  FileSelectorModalProps,
  FileSourceEnum,
  FileUploaderDropZone,
} from '@systemeio/file-manager'
import { FieldErrorAndDescription } from '@systemeio/ui'
import { ComponentProps, useRef, useState } from 'react'
import { FileListItem } from 'shared/components/file-list/file-list-item'

interface FileUploaderProps {
  files: { id: number; name: string; path: string; filename: string }[]
  source: FileSourceEnum
  isPreFetching?: boolean
  error?: string
  errors?: (string | undefined)[]
  onSelect: ComponentProps<typeof FileSelectorModal>['onSelect']
  onDelete: (file: { id: number; name: string; path: string; filename: string }) => void
}

export const FileUploaderWithListedFiles = ({
  files,
  source,
  isPreFetching,
  error,
  errors,
  onSelect,
  onDelete,
}: FileUploaderProps) => {
  const [opened, setOpened] = useState(false)
  const uploaderRef = useRef() as NonNullable<
    FileSelectorModalProps['fileUploaderModalProps']
  >['uploaderRef']
  const fileSelectorRef = useRef() as FileSelectorModalProps['fileSelectorRef']

  return (
    <>
      {files.length > 0 && (
        <div className={'flex flex-col gap-4'}>
          {files.map((item, index) => {
            return (
              <div key={`${item.id}-${index}`}>
                <FileListItem file={item} onDelete={() => onDelete(item)} />
                {errors && (
                  <FieldErrorAndDescription error={errors[index]} errorClassName={'mt-2'} />
                )}
              </div>
            )
          })}
        </div>
      )}

      <FileUploaderDropZone
        openNativeWindow={false}
        isPreFetching={isPreFetching}
        error={error}
        onClick={() => {
          setOpened(true)
        }}
        onSelectFile={(file: File) => {
          setOpened(true)
          setTimeout(() => {
            fileSelectorRef?.current.setFileUploadModalOpen(true)
            uploaderRef?.current?.setWaitingUploadFiles(prev => [...prev, { file }])
          })
        }}
      />

      <FileSelectorModal
        opened={opened}
        uploadingFromSource={source}
        fileSelectorRef={fileSelectorRef}
        fileUploaderModalProps={{
          uploaderRef,
          imageCropperModalProps: {
            imageCropperProps: {
              aspectRatio: NaN,
            },
          },
        }}
        onSelect={file => {
          setOpened(false)
          onSelect(file)
        }}
        onClose={() => setOpened(false)}
      />
    </>
  )
}
